// extracted by mini-css-extract-plugin
module.exports = {"timer":"PhaseTimer_timer__Fe2mm","warning":"PhaseTimer_warning__9G3HA"};